import { Dispatch, SetStateAction } from 'react';
import { useMediaQuery } from '@mui/material';
import { TabsNav, SelectNav, IOperationAllow } from '../common';
import { labels } from '.';

export const Nav = ({
  currentTab,
  operations,
  setCurrentTab,
  operationsPage,
}: {
  currentTab: number;
  operations: IOperationAllow[];
  setCurrentTab: Dispatch<SetStateAction<number>>;
  operationsPage?: boolean;
}) => {
  const matchesTabsBreakpoint = useMediaQuery('(min-width:40em)', {
    noSsr: true,
  });

  return matchesTabsBreakpoint ? (
    <TabsNav
      currentTab={currentTab}
      labels={labels(operations, operationsPage)}
      onChange={setCurrentTab}
      ariaLabel="help desk tabs"
    />
  ) : (
    <SelectNav
      currentTab={currentTab}
      labels={labels(operations, operationsPage)}
      onChange={setCurrentTab}
      ariaLabel="help desk tabs"
    />
  );
};
